import { ReactNode } from 'react';

import { PromoVideo, Text, Colors } from '@rockalingua/ui';

import { Container, HeroContent, VideoContainer } from './Hero.styled';

type HeroProps = {
  button: ReactNode;
  title: string;
  subtitle: string;
  description: string;
};

export default function Hero({
  title,
  subtitle,
  description,
  button,
}: HeroProps) {
  return (
    <Container>
      <HeroContent>
        <Text variant="grey-56-bold" color={Colors.BLUE} as="h1">
          {title}
        </Text>
        <Text variant="title-mid-grey-32" color={Colors.NEUTRAL_VARIANTS[90]}>
          {subtitle}
        </Text>
        {description && (
          <Text
            variant="title-small-grey-22"
            color={Colors.NEUTRAL_VARIANTS[100]}
          >
            {description}
          </Text>
        )}
        {button}
        <Text variant="grey-16-bold" color={Colors.NEUTRAL_VARIANTS[100]}>
          No credit card required
        </Text>
      </HeroContent>
      <VideoContainer>
        <PromoVideo />
      </VideoContainer>
    </Container>
  );
}
